import styled from 'styled-components'
import { Button, SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'
import GiftSvg from 'assets/svgr-icons/Gift.svg'

export const Footer = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px 16px 12px;
  border-top: 1px solid ${COLORS.borderColor};
`

export const GenerateButtonWrapper = styled.div`
  width: 100%;
`

export const GenerateButton = styled(Button)<{ $isPremium: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  ${premiumButtonStyles}
`

export const GiftIcon = styled(GiftSvg)`
  color: ${COLORS.white};
  margin-left: 2px;
`

export const CreditsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${COLORS.white};
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`

export const SpinningLoaderWrapper = styled(SpinningLoader)<{
  $isVisible: boolean
}>`
  width: 16px;
  height: 16px;
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`

export const UpgradeHint = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
`

export const UpgradeHintText = styled.span`
  color: ${COLORS.secondary};
`

export const UpgradeLink = styled.button`
  padding: 0;
  border: none;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  background: none;
  color: ${COLORS.primaryDark};
`
